import {apiGet, apiPostGet} from "@/services/api.ts";
import type {IAuthRes, IGetUserRes} from "@/app/auth/api/res.ts";

export const getUser = async () => {
  return await apiGet<IGetUserRes>("/auth/user").then(res => res.user);
}

export const register = async (data: any) => {
  return await apiPostGet("/auth/register", data)
}

export const loginCredentials = async (data: any) => {
  return await apiPostGet<IAuthRes>("/auth/login", data)
};

export const logout = async () => {
  return await apiPostGet("/auth/logout");
}

export const forgotPassword = async (data: any) => {
  return await apiPostGet("/auth/forgot_password", data)
}

export const verifyResetPassword = async (data: any) => {
  return await apiPostGet("/auth/verify_reset_password", data)
}

export const resetPassword = async (data: any) => {
  return await apiPostGet<IAuthRes>("/auth/reset_password", data)
}